const commonTracker = () => import('./common-tracker.js')
const errorTracker = () => import('./error-tracker.js')
const productRecommendationTracker = () => import('./product-recommendation-tracker.js')
const promotionTracker = () => import('./promotion-tracker.js')
const featuredSellerTracker = () => import('./featured-seller-tracker.js')
const topProductTracker = () => import('./top-product-tracker.js')
const topProductShareTracker = () => import('./top-product-share-tracker.js')
const missionTracker = () => import('./mission-tracker.js')
const bonusCommissionSellerTracker = () => import('./bonus-commission-seller-tracker.js')
const tagLinkTracker = () => import('./tag-link-tracker.js')

const caller = {
  commonTracker,
  errorTracker,
  productRecommendationTracker,
  promotionTracker,
  featuredSellerTracker,
  topProductShareTracker,
  topProductTracker,
  missionTracker,
  bonusCommissionSellerTracker,
  tagLinkTracker
}

const loadedModules = {}

export default {
  /**
   *
   * @param {String} callerName
   * @param {String} fn
   * @param  {...any} params
   */
  call (callerName, fn, ...params) {
    const component = caller[callerName]
    if (loadedModules[callerName]) {
      loadedModules[callerName][fn](...params)
      return
    }
    component().then(lib => {
      loadedModules[callerName] = lib
      lib[fn](...params)
    })
  }
}
